/*
 * @Author: luting
 * @Date: 2022-05-05 19:53:50
 * @lastEditors: luting
 * @LastEditTime: 2022-08-30 10:12:15
 */
import React, { forwardRef, useImperativeHandle } from 'react';
import { useIntl } from 'react-intl';
import { Input, Form } from 'sup-ui';
import { FormComponentProps } from 'sup-ui/lib/form';
import messages from './messages';
import { IRecipientType } from './types';

interface IPersonForm extends FormComponentProps {
  record: IRecipientType | null;
}

const formItemLayout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 20,
  },
};

const PersonForm = forwardRef<FormComponentProps, IPersonForm>((props, ref) => {
  const intl = useIntl();
  const { form, record } = props;
  const { getFieldDecorator } = form;

  useImperativeHandle(ref, () => ({
    form,
  }));

  return (
    <Form {...formItemLayout}>
      <Form.Item label={intl.formatMessage(messages.recipient)} colon={false}>
        {getFieldDecorator('name', {
          initialValue: record?.name,
          rules: [
            {
              required: true,
              message: intl.formatMessage(messages.placeholder) + intl.formatMessage(messages.recipient),
            },
          ],
        })(<Input maxLength="64" />)}
      </Form.Item>
      <Form.Item label={intl.formatMessage(messages.email)} colon={false}>
        {getFieldDecorator('address', {
          initialValue: record?.address,
          validateTrigger: ['onBlur'],
          rules: [
            {
              required: true,
              message: intl.formatMessage(messages.placeholder) + intl.formatMessage(messages.email),
            },
            {
              pattern: new RegExp(/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/),
              message: intl.formatMessage(messages.emailRules),
            },
          ],
        })(<Input maxLength="64" />)}
      </Form.Item>
    </Form>
  );
});

export default Form.create()(PersonForm);
